import client from './api-client';

export const getConfiguracionForm34 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form34: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGastosGrilla = async(query) => {
    try {
        
        const response = await client.getSelect(`gestion-implicado/gastos/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGrilla: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

